import { Button } from '@quintype/em/components/button';
import React from 'react';
import { Close } from '../../atoms/close-svg';
import styles from './confirmation-popup.module.css';

interface IConfirmationPopupProps {
  onCancel: () => void;
  onDiscard: () => void;
  onSave?: () => void;
  headingTxt?: string;
  subheadingTxt?: string;
  discardBtnTxt?: string;
  saveBtnTxt?: string;
  hideSaveButton?: boolean;
  showGoBackButton?: boolean;
  goBackBtnTxt?: string;
}

export const ConfirmationPopup = ({
  onCancel,
  onDiscard,
  onSave,
  headingTxt = `Do you want to discard your changes?`,
  subheadingTxt = `You've made changes that haven't been saved yet. Please confirm if you'd like to discard your changes.`,
  discardBtnTxt = `Discard & Continue`,
  saveBtnTxt = `Save & Continue`,
  goBackBtnTxt = `Go Back`,
  hideSaveButton = false,
  showGoBackButton = false
}: IConfirmationPopupProps) => {
  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupWrapper}>
        <div className={styles.closeButton} onClick={onCancel}>
          <Close />
        </div>
        <div className={styles.heading}>{headingTxt}</div>
        <div className={styles.subheading}>{subheadingTxt}</div>
        <div className={styles.btnWrapper}>
          <Button onClick={onDiscard}>{discardBtnTxt}</Button>
          {showGoBackButton && (
            <Button type="primary" onClick={onCancel}>{goBackBtnTxt}</Button>
          )}

          {!hideSaveButton && onSave && (
              <Button type="primary" onClick={() => onSave()}>
                {saveBtnTxt}
              </Button>
            )}
        </div>
      </div>
    </div>
  );
};
